module.exports = __webpack_public_path__ + "img/gmtc.b978becd.jpg";